/* eslint-disable no-unused-vars */
import {
  Alert,
  Autocomplete,
  Breadcrumbs,
  Button,
  Card,
  CardContent,
  Divider,
  Grid,
  Link,
  Paper,
  Snackbar,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { NavLink, useNavigate } from "react-router-dom";
import { Add as AddIcon } from "@mui/icons-material";
import Loading from "../components/Loading";
import axios from "../../CustomAxios";

function CreateProductionReport() {
  const [apCompany, setApCompany] = useState(false);
  const [companies, setCompanies] = useState(false);
  const [selectedApCompany, setSelectedApCompany] = useState("");
  const [jobs, setJobs] = useState([{ label: "" }]);
  const [err, setErr] = useState("");
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();

  const [state, setState] = useState({
    open: false,
    vertical: "top",
    horizontal: "center",
  });
  const { vertical, horizontal, open } = state;
  const snackRef = useRef(null);
  const handleClick = (newState) => () => {
    setState({ open: true, ...newState });
  };

  // const handleUpdateDPR = () => {
  //   navigate(`/dashboard/production_report?selectedCompany=${selectedApCompany}`);
  // };

  const handleClose = () => {
    setState({ ...state, open: false });
  };

  const [jobData, setJobData] = useState([
    {
      job_id: "",
      name: "",
      plates: [],
      plate_id: "",
      baking_quantity: 0,
      ctp_quantity: 0,
      index: 0,
      ap_user_name: "",
      comment: "",
      totalCtp: 0,
      totalBake: 0,
    },
  ]);
  const [maxbakeandCtp, setmaxbakeandCtp] = useState({
    maxBake: 0,
    maxCtp: 0,
  });
  const [loader, setLoader] = useState(true);
  const [disable, setDisable] = useState(false);
  const [plates, setPlates] = useState([
    {
      plateId: "",
      baking_quantity: "",
      ctp_quantity: "",
    },
  ]);

  const getPlateDetails = async (tempPlates) => {
    let rows = [];
    await Promise.all(
      tempPlates.map(async (element, index) => {
        try {
          const authData = JSON.parse(localStorage.getItem("AuthData"));
          const config = {
            headers: {
              Authorization: "Bearer " + authData.access_token,
            },
          };
          const { data } = await axios.get(
            `/api/v1/${authData?.type}/plate_inventory/${element.plate_id}/details`,
            config
          );
          rows.push({
            label: `${data.data.height}X${data.data.width}X${data.data.thickness}`,
            id: element._id,
            plate_id: element.plate_id,
            bake: element.bake,
            ctp: element.ctp_plate_count,
          });
        } catch (error) {
          setErr("Error in fetching plate details");
        }
      })
    );
    return rows;
  };

  const addPlate = () => {
    setPlates((prev) => [
      ...prev,
      {
        plateId: "",
        ctp_quantity: "",
        baking_quantity: "",
      },
    ]);
    setJobData((prev) => [
      ...prev,
      {
        job_id: "",
        name: "",
        plates: [],
        plate_id: "",
        baking_quantity: 0,
        ctp_quantity: 0,
        index: jobData.length,
        comment: "",
        totalCtp: 0,
        totalBake: 0,
      },
    ]);
  };

  const handleSubmit = async () => {
    try {
      const authData = JSON.parse(localStorage.getItem("AuthData"));
      const isAnyPlateEmpty = jobData.some((job) => job.plate_id === "");
      if (isAnyPlateEmpty) {
        setErr("Please fill all plate details sections.");
      }


      const report = jobData.map(
        ({ job_id, plate_id, baking_quantity, ctp_quantity, comment, unique_id }) => ({
          job_id: job_id,
          plate: plate_id,
          baking_quantity: baking_quantity,
          ctp_quantity: ctp_quantity,
          ap_company: apCompany,
          action_by: authData.user_id,
          comment: comment,
          unique_id: unique_id,
          audit_logs: [
            {
              action_by: authData.user_id,
              timestamp: new Date(),
              action: "create_dpr",
            },
          ],
        })
      );

      const config = {
        headers: {
          Authorization: "Bearer " + authData.access_token,
        },
      };
      const { data } = await axios.post(
        `/api/v1/${authData?.type}/production_report`,
        { reports: report },
        config
      );
      if (data.success) {
        setLoader(false);
        setSuccess(true);
        setErr("");
        snackRef.current.click();
        navigate(
          `/dashboard/production-report?ap_company=${selectedApCompany.id}`,
          {
            state: {
              success: true,
              message: "DPR Updated Successfully",
            },
          }
        );
      }
    } catch (e) {
      setLoader(false);
      setErr(e.response.data.error);
      snackRef.current.click();
    }
  };

  const removeJob = (jobToRemove) => {
    // Filter out the plate to be removed
    // console.log("jobtoremove is",jobToRemove);
    const updatedJobs = jobData.filter((job) => job !== jobToRemove);
    // Update the state with the new array
    setJobData(updatedJobs);
  };

  const handleApCompanyClick = async (e, newValue) => {
    setSelectedApCompany(newValue);

    const authData = JSON.parse(localStorage.getItem("AuthData"));
    const config = {
      headers: {
        Authorization: "Bearer " + authData.access_token,
      },
    };

    const data = await axios.get(
      `/api/v1/${authData?.type}/jobs/?ap_company_id=${newValue.id}`,
      config
    );
    // console.log("Data for plates is", data.data.data.data);
    let tempData = data.data.data.data;

    let rows = [];
    // eslint-disable-next-line
    const temp = tempData.map((element, index) => {
      if (
        element.current_status !== "new" &&
        element.current_status !== "requested" &&
        element.current_status !== "studio"
      ) {
        rows.push({
          label: element.job_id,
          id: element._id,
          name: element.name,
          plates: element.plates,
        });
        return element;
      }
    });

    setJobs(rows);
    // setPlateData(rows);
    setApCompany(newValue.id);
  };


  const getTotalDPR = async (job_id, unique_id, index) => {
    try {
      const authData = JSON.parse(localStorage.getItem("AuthData"));
      const config = {
        headers: {
          Authorization: "Bearer " + authData.access_token,
        },
      };
      const { data } = await axios.get(
        `/api/v1/${authData?.type}/production_report/total/${job_id}/${unique_id}`,
        config
      );
      let jb = jobData;
      jb[index].totalBake = data.data?.bake || 0;
      jb[index].totalCtp = data.data?.ctp || 0;
      setJobData(jb);
    } catch (error) {
      setErr("Error in fetching total quantity");
    }
  };

  async function getData() {
    const userData = JSON.parse(localStorage.getItem("AuthData"));
    const config = {
      headers: {
        Authorization: "Bearer " + userData.access_token,
      },
    };
    const { data } = await axios.get(
      `/api/v1/${userData?.type}/plate_inventory/inward_outward/ap_companies`,
      config
    );
    let companyData = data?.data;
    let rows = [];
    // eslint-disable-next-line
    const tempRow = companyData?.map((element, index) => {
      rows.push({ label: element.name, id: element._id });
      return element;
    });
    // console.log("Data is", data);
    setCompanies(rows);
    setLoader(false);
  }

  useEffect(() => {
    getData();
  }, []);

  function showErrorAlert(message) {
    setErr(message);
    snackRef.current.click();
    setDisable(true);
  }
  const [plateMaxCtpMap, setPlateMaxCtpMap] = useState({});
  const [plateMaxBakeMap, setPlateMaxBakeMap] = useState({});

  return (
    <>
      <form noValidate autoComplete="off">
        <Button
          ref={snackRef}
          style={{ display: "none" }}
          onClick={handleClick({ vertical: "top", horizontal: "center" })}
        >
          Click
        </Button>
        <Snackbar
          anchorOrigin={{ vertical, horizontal }}
          open={open}
          onClose={handleClose}
          key={vertical + horizontal}
        >
          {err ? (
            <Alert mt={2} mb={4} severity="error">
              {err}
            </Alert>
          ) : success ? (
            <Alert mt={2} mb={4} severity="success">
              Challan Updated Successfully
            </Alert>
          ) : null}
        </Snackbar>
        <Grid
          justifyContent="space-between"
          alignItems="center"
          container
          spacing={10}
          mb={4}
        >
          <Grid item>
            <Typography
              variant="h4"
              gutterBottom
              display="inline"
              sx={{ fontWeight: 600 }}
              color="primary"
            >
              Create Production Report
            </Typography>
          </Grid>
          <Grid item>
            <Breadcrumbs aria-label="Breadcrumb" mt={2}>
              <Link component={NavLink} to="/dashboard/tasks">
                Dashboard
              </Link>
              <Link component={NavLink} to="/dashboard/production-report">
                Production Report
              </Link>

              <Typography>Create</Typography>
            </Breadcrumbs>
          </Grid>
        </Grid>
        {!loader ? (
          <>
            <Card mb={6}>
              <CardContent>
                <Paper elevation={3} style={{ padding: "2%" }}>
                  <Grid container spacing={5}>
                    <Grid item xs={12} lg={12} md={12}>
                      <Typography variant="h6" gutterBottom>
                        AP Company
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={12} lg={12}>
                      <Autocomplete
                        disablePortal
                        disableClearable
                        options={companies}
                        renderInput={(params) => (
                          <TextField {...params} label="Select AP Company" />
                        )}
                        value={selectedApCompany}
                        onChange={handleApCompanyClick}
                      />
                    </Grid>

                    {/* <Grid item xs={12} lg={12} md={12}>
                      <Typography variant="h6" color="primary" gutterBottom>
                        Job Details
                      </Typography>
                    </Grid> */}
                    {!loader &&
                      jobData.map((job, index) => {
                        return (
                          <>
                            <Grid
                              item
                              xs={12}
                              md={2}
                              lg={2}
                            // sx={{ marginRight: "7.5px" }}
                            >
                              <Autocomplete
                                disablePortal
                                size="small"
                                options={jobs}
                                disableClearable={true}
                                onChange={async (e, newValue) => {
                                  const updatedJobDetails = [...jobData];

                                  updatedJobDetails[index].job_id = newValue.id;
                                  updatedJobDetails[index].name = newValue.name;
                                  const tempPlates = newValue.plates;
                                  const rows = await getPlateDetails(
                                    tempPlates
                                  );

                                  updatedJobDetails[index].plates = rows;


                                  setJobData(updatedJobDetails);

                                  // const updatedPlateDetails = [...plates]
                                  // updatedPlateDetails[index].plateId = newValue.id;
                                  // setPlates(updatedPlateDetails);
                                }}
                                renderInput={(params) => (
                                  <TextField {...params} label="Job Id" />
                                )}
                              />
                            </Grid>
                            <Grid item xs={12} md={2} lg={2}>
                              <TextField
                                size="small"
                                sx={{ width: "100%" }}
                                name={String(index)}
                                value={job.name}
                                label="Job Name"
                              />
                            </Grid>

                            <Grid item xs={12} md={2} lg={2}>
                              <Autocomplete
                                disablePortal
                                size="small"
                                options={job.plates}
                                disableClearable={true}
                                onChange={(e, newValue) => {
                                  const updatedJobDetails = [...jobData];

                                  const selectedPlate = job.plates.find(
                                    (plate) => plate.id === newValue.id
                                  );
                                  if (selectedPlate) {
                                    maxbakeandCtp.maxBake = selectedPlate.bake;
                                    maxbakeandCtp.maxCtp = selectedPlate.ctp;
                                    setPlateMaxCtpMap((prevState) => ({
                                      ...prevState,
                                      [newValue.id]: selectedPlate.ctp,
                                    }));
                                    setPlateMaxBakeMap((prevState) => ({
                                      ...prevState,
                                      [newValue.id]: selectedPlate.bake,
                                    }));
                                  }

                                  updatedJobDetails[index].plate_id =
                                    newValue.plate_id;
                                  updatedJobDetails[index].unique_id = newValue.id
                                  getTotalDPR(
                                    jobData[index].job_id,
                                    newValue.id,
                                    index
                                  );
                                  setJobData(updatedJobDetails);
                                }}
                                renderInput={(params) => (
                                  <TextField {...params} label="Plates" />
                                )}
                              />
                            </Grid>
                            <Grid item xs={12} md={1} lg={1}>
                              <TextField
                                size="small"
                                sx={{ width: "100%" }}
                                value={
                                  plateMaxBakeMap[jobData[index].unique_id] || 0
                                }
                                disabled
                                label="Max Bake"
                              />
                            </Grid>
                            <Grid item xs={12} md={1} lg={1}>
                              <TextField
                                size="small"
                                sx={{ width: "100%" }}
                                value={
                                  plateMaxCtpMap[jobData[index].unique_id] || 0
                                }
                                disabled
                                label="Max CTP"
                              />
                            </Grid>
                            <Grid item xs={12} md={2} lg={2}>
                              <TextField
                                size="small"
                                sx={{ width: "100%" }}
                                value={jobData[index].totalBake}
                                disabled
                                label="Total Bake DPR Entry"
                              />
                            </Grid>
                            <Grid item xs={12} md={2} lg={2}>
                              <TextField
                                size="small"
                                sx={{ width: "100%" }}
                                value={jobData[index].totalCtp}
                                disabled
                                label="Total CTP DPR entry"
                              />
                            </Grid>

                            <Grid item xs={12} md={2} lg={2}>
                              <TextField
                                size="small"
                                name={String(index)}
                                sx={{ width: "100%" }}
                                required
                                onChange={(e) => {
                                  const updatedPlates = [...jobData];
                                  if (e.target.value > maxbakeandCtp.maxBake) {
                                    showErrorAlert(
                                      "Please enter a lower amount; you are exceeding the maximum bake quantity"
                                    );
                                    return;
                                  }
                                  if (
                                    e.target.value >
                                    parseInt(maxbakeandCtp.maxBake) -
                                    parseInt(jobData[index].totalBake)
                                  ) {
                                    showErrorAlert(
                                      "Cannot make entry as the total will exceed max bake quantity"
                                    );
                                    return;
                                  }
                                  setDisable(false);
                                  updatedPlates[
                                    Number(e.target.name)
                                  ].baking_quantity = Number(e.target.value);
                                  setJobData(updatedPlates);
                                }}
                                value={jobData.baking_quantity}
                                label="Bake Quantity"
                              />
                            </Grid>

                            <Grid
                              item
                              xs={12}
                              md={2}
                              lg={2}
                            // sx={{
                            //   borderRight: "1px solid #ccc",
                            //   paddingRight: "7px",
                            // }}
                            >
                              <TextField
                                size="small"
                                fullWidth
                                name={String(index)}
                                required
                                onChange={(e) => {
                                  const updatedPlates = [...jobData];
                                  if (e.target.value > maxbakeandCtp.maxCtp) {
                                    showErrorAlert(
                                      "Please enter a lower amount; you are exceeding the maximum ctp quantity"
                                    );
                                    return;
                                  }
                                  if (
                                    e.target.value >
                                    parseInt(maxbakeandCtp.maxCtp) -
                                    parseInt(jobData[index].totalCtp)
                                  ) {
                                    showErrorAlert(
                                      "Cannot make entry as the total will exceed max CTP quantity"
                                    );
                                    return;
                                  }
                                  setDisable(false);
                                  updatedPlates[
                                    Number(e.target.name)
                                  ].ctp_quantity = Number(e.target.value);
                                  setJobData(updatedPlates);
                                }}
                                value={jobData.ctp_quantity}
                                label="CTP quantity"
                              />
                            </Grid>

                            <Grid item xs={12} md={6} lg={6}>
                              <TextField
                                size="small"
                                fullWidth
                                onChange={(e) => {

                                  const updatedJobDetails = [...jobData];
                                  updatedJobDetails[index].comment =
                                    e.target.value;
                                  setJobData(updatedJobDetails);
                                }}
                                // value={jobData.comment}
                                // disabled
                                label="Comment"
                              />
                            </Grid>
                            <Grid item xs={1}>
                              {
                                // eslint-disable-next-line
                                index != 0 && (
                                  <CloseIcon
                                    onClick={() => {
                                      removeJob(job);
                                    }}
                                    sx={{
                                      height: "100%",
                                      borderLeft: 0,
                                      padding: "0 2px",
                                      cursor: "pointer",
                                    }}
                                  />
                                )
                              }
                            </Grid>
                          </>
                        );
                      })}

                    <Grid item xs={12}>
                      <Button
                        onClick={addPlate}
                        mr={2}
                        variant="contained"
                        color="primary"
                        sx={{
                          marginBottom: "20px",
                        }}
                      >
                        Add Job
                        <AddIcon />
                      </Button>
                    </Grid>
                  </Grid>
                  <Divider />
                  <Grid item xs={12} md={12} lg={12}>
                    <Button
                      onClick={handleSubmit}
                      mr={2}
                      variant="contained"
                      color="primary"
                      disabled={disable}
                      style={{ textAlign: "center", marginTop: "20px" }}
                    >
                      Create DPR
                    </Button>
                  </Grid>
                </Paper>
              </CardContent>
            </Card>

            {/* <div style={{ display: "flex", justifyContent: "flex-start" }}>
             
            </div> */}
          </>
        ) : (
          <Loading />
        )}
      </form>
    </>
  );
}

export default CreateProductionReport;
